
    <div class="input-wrapper">
      <div class="row">
        <div class="col">
          <h5 class="title" translate="msgNewinMyLion">
            What's new in MyLion?
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h6 style="margin-bottom: 0;">{{ alert.header }}</h6>
          <p>{{ alert.body }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col" style="text-align: center;">
          <app-button (click)="cancel()" style="display: inline-block;"
            >THANKS!</app-button
          >
        </div>
      </div>
    </div>
  